
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppCommonModule } from 'src/app/common.module';
import { DashboardViewComponent } from 'src/app/components/views/dashboard/view-dashboard.component';
import { sections } from 'src/app/menu/super-admin';

@Component({
  selector: 'app-super-admin-menu-page',
  templateUrl: './menu.page.html',
  styleUrls: ['./menu.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    RouterLink,
    DashboardViewComponent,
  ],
})
export class SuperAdminMenuPage {
  readonly sections = sections;
}
